import './admin.css';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Bell, Boxes, Calculator, ClipboardList, LayoutDashboard, Package, Receipt, Settings, UtensilsCrossed } from 'lucide-react';
import useLowStock from '../../hooks/useLowStock';

export default function AdminLayout() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const { lowCount, alert, dismiss } = useLowStock();

  const handleLogout = () => { logout(); navigate('/admin/login'); };

  const serviceNav = [
    { to: '/admin', label: 'Dashboard', icon: Bell },
  ];

  const configNav = [
    { to: '/admin/productos', label: 'Productos', icon: Package },
    { to: '/admin/inventario', label: 'Inventario', icon: Boxes, badge: lowCount },
    { to: '/admin/mesas', label: 'Mesas', icon: LayoutDashboard },
    { to: '/admin/pedidos', label: 'Pedidos', icon: ClipboardList },
    { to: '/admin/facturas', label: 'Facturas', icon: Receipt },
    { to: '/admin/cierre-caja', label: 'Cierre de caja', icon: Calculator },
    { to: '/admin/configuracion', label: 'Configuración', icon: Settings },
  ];

  const renderLink = (n) => {
    const Icon = n.icon;
    return (
      <Link key={n.to} to={n.to} className={loc.pathname === n.to ? 'active' : ''}>
        <Icon size={16} />
        {n.label}
        {n.badge > 0 && <span className="neon-admin-nav-badge">{n.badge}</span>}
      </Link>
    );
  };

  return (
    <div className="neon-admin">
      <aside className="neon-admin-sidebar">
        <div className="neon-admin-brand">
          <UtensilsCrossed size={18} />
          NEON Admin
        </div>
        <nav>
          <div className="neon-admin-nav-section">Servicio</div>
          {serviceNav.map(renderLink)}
          {isAdmin && (
            <>
              <div className="neon-admin-nav-separator" />
              <div className="neon-admin-nav-section">Configuración</div>
              {configNav.map(renderLink)}
            </>
          )}
        </nav>
        <div className="neon-admin-user">
          <span>{user?.name}</span>
          <button onClick={handleLogout}>Salir</button>
        </div>
      </aside>
      <main className="neon-admin-main">
        <Outlet />
      </main>

      {alert && (
        <div className="neon-lowstock-toast" role="alert">
          <span className="neon-lowstock-icon">⚠️</span>
          <div className="neon-lowstock-body">
            <b>Stock bajo</b>
            <span>{alert.ingredients.map((i) => i.name).join(', ')}</span>
          </div>
          <button type="button" onClick={() => { dismiss(); navigate('/admin/inventario'); }}>Ver</button>
          <button type="button" className="neon-lowstock-x" onClick={dismiss}>✕</button>
        </div>
      )}
    </div>
  );
}
